import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const UnitMeasures = ({ units, onChange, value, isReadOnly }) => {
	const { t } = useTranslation();

	// Opciones por defecto si no se pasan como prop
	const defaultUnidades = [
		{ value: "ph", label: t("measures.ph") },
		{ value: "uscm", label: t("measures.uscm") },
		{ value: "mgl", label: t("measures.mgl") },
		{ value: "percent", label: t("measures.percent") },
		{ value: "unf", label: t("measures.unf") },
		{ value: "ufc_100ml", label: t("measures.ufc_100ml") },
		{ value: "ufc_1ml", label: t("measures.ufc_1ml") },
		{ value: "mgl_ptco", label: t("measures.mgl_ptco") },
		{ value: "c_ind_dilucion", label: t("measures.c_ind_dilucion") },
		{ value: "ugl", label: t("measures.ugl") },
		{ value: "ufp_100ml", label: t("measures.ufp_100ml") },
		{ value: "mg_o2_l", label: t("measures.mg_o2_l") },
		{ value: "mgl_caco3", label: t("measures.mgl_caco3") },
		{ value: "bql", label: t("measures.bql") },
		{ value: "msv", label: t("measures.msv") },
		{ value: "ppm", label: t("measures.ppm") },
		{ value: "celsius", label: t("measures.celsius") },
		{ value: "10_3_ul", label: t("measures.10_3_ul") },
		{ value: "10_16_ul", label: t("measures.10_16_ul") },
		{ value: "g_dl", label: t("measures.g_dl") },
		{ value: "fl", label: t("measures.fl") },
		{ value: "pg", label: t("measures.pg") },
		{ value: "mg_dl", label: t("measures.mg_dl") },
		{ value: "ui_l", label: t("measures.ui_l") },
		{ value: "per_ul", label: t("measures.per_ul") },
		{ value: "ml_min_1_73m2", label: t("measures.ml_min_1_73m2") }
	];
	
	const opciones = units || defaultUnidades;

	// Normalizamos el valor seleccionado
	const selectedOption =
	typeof value === 'string'
		? opciones.find(opt => opt.value === value)
		: value && value.value
		? opciones.find(opt => opt.value === value.value)
		: null;

	return (
	<Select
		className="select"
        classNamePrefix="sd-select"
		options={opciones.sort((a,b) => a.label.localeCompare(b.label))}
		onChange={onChange}
		value={selectedOption}
		name='unitMeasure'
		placeholder={t("measures.selectMeasure")}
		isClearable
		isDisabled={isReadOnly}
	/>
	);
};

export default UnitMeasures;